import './index.scss';

const blockImageText = () => {
	
};

export default blockImageText;
